import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {NatGetApplicationStatusDetail} from '../repository/NatGetApplicationStatus'
import {
    NatAbsenceContactAddress,
    NatContactAddressOnEmergency,
    NatContactAddressOnEmergencyDetail,
    NatFamilyStructure,
    NatRentAdminContactAddress,
} from '../repository/NatGetContactAddressOnEmergency'
import {
    SecondaryTableCell,
    SecondaryTableRowName,
    StyledTableCaption,
    TableRowName,
    TableRowNameTop,
} from '../../../../styledComponents/adminPage/Table'
import {
    APPLY_CATEGORY,
    HAVE_OR_NOT,
    MESSAGE_TYPE,
    RESIDENCE_STYLE,
    RESIDENT_APPLY_PROCESS,
    RESIDENT_APPLY_STATUS,
} from '../../../../CodeMaster'
import {getApplicant} from '../common/helper/NatApplicationHelper'
import {BackLink, PrintLink} from '../../../../styledComponents/adminPage/Links'
import {Box, Table, TableBody, TableRow} from '@mui/material'
import moment from 'moment'
import {
    ApplyReceptionOutlinedButton,
    ApplyRejectionOutlinedButton,
    SpApplicationDetailInfoContent,
    SpApplicationDetailInfoContentName,
    SpApplicationDetailInfoContentValue,
    SpApplicationInfoArea,
    SpApplicationInfoFooter,
    SpApplyCategory,
    SpApplyStatusCell,
    SpBackLinkArea,
    SpPageFooterArea,
    StyledTableCell,
} from '../common/admin/NatAdminApplicationCommon'
import {getFormattedAddress, getFormattedDate} from './helper/NatContactAddressOnEmergencyHelper'
import {getRandomKey, getStringOrEmptyString, toFullWidthNumber} from '../../../common/util/Natutil'
import {
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    RightRowFlexContainer,
} from '../../../../styledComponents/FlexComponents'
import {
    NatContactAddressEmergencyApplicationDocument,
} from '../common/admin/print/NatContactAddressEmergencyApplicationDocument'
import NatAdminApplicationRejectionDialog from '../common/admin/NatAdminApplicationRejectionDialog'
import ReactToPrint from 'react-to-print'
import {
    NatPutRejectionContactAddressOnEmergencyRequest,
    NatPutRejectionContactAddressOnEmergencyResponse,
} from '../repository/NatPutRejectionContactAddressOnEmergency'
import {Messages} from '../../../../Messages'
import {HeadingAreaMessageParams} from '../../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import NatAdminApplicationReceptionDialog from '../common/admin/NatAdminApplicationReceptionDialog'
import {
    NatPutApprovalContactAddressOnEmergencyResponse,
    NatPutApprovalsContactAddressOnEmergencyRequest,
} from '../repository/NatPutReceptionContactAddressOnEmergency'
import {NatApplicationStatusComponent} from '../common/admin/NatApplicationStatusComponent'
import {HKConstants} from '../../../../HKConstants'
import AuthorityChecker from '../../../../components/AuthorityChecker'
import {formatDateTimeWithoutSeconds} from '../../../../formatters/formatDate'
import {NatAdminSpApplicationTabComponent} from '../common/admin/NatAdminSpApplicationTabComponent'
import {Check, Close} from '@mui/icons-material'
import {AppAdminContext} from '../../../../app/AppAdminContext'
import {PrintContentArea} from '../common/admin/print/NatAdminApplicatioPrintCommonStyle'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applyId: string
    applicationRepo: NatApplicationRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    contactAddressOnEmergencyDetail: NatContactAddressOnEmergencyDetail
    applicationStatusDetail: NatGetApplicationStatusDetail
    rejectionComment: string
    isLoadCompleted: boolean
    dialogStatus: Nullable<DialogContentType>
}

type DialogContentType = 'reception' | 'rejection'

class NatAdminContactAddressOnEmergencyPage extends Component<Props & AdminPagePropsSet, States> {
    declare context: React.ContextType<typeof AppAdminContext>
    ownUrl: string
    componentRef: RefObject<HTMLDivElement>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {
            contactAddressOnEmergencyDetail: {
                applyId: '',
                applyStatus: '',
                condominiumName: '',
                ridgeName: '',
                roomNumber: '',
                applicantFamilyName: '',
                applicantFirstName: '',
                applyDate: '',
                residenceStyle: '',
                occupancyDate: '',
                contactAddressOnEmergency: {
                    familyName: '',
                    firstName: '',
                    zipCode: '',
                    prefecture: '',
                    address2: '',
                    address3: '',
                    buildingRoomNumber: '',
                    fixedPhoneNumber: '',
                    mobilePhoneNumber: '',
                },
                absenceContactAddress: {
                    familyName: '',
                    firstName: '',
                    zipCode: '',
                    prefecture: '',
                    address2: '',
                    address3: '',
                    buildingRoomNumber: '',
                    fixedPhoneNumber: '',
                    mobilePhoneNumber: '',
                },
                rentAdminContactAddressFlag: '',
                rentAdminContactAddress: {
                    name: '',
                    zipCode: '',
                    prefecture: '',
                    address2: '',
                    address3: '',
                    buildingRoomNumber: '',
                    phoneNumber: '',
                },
                familyStructure: [],
                version: 0,
            },
            applicationStatusDetail: {
                applyStatusInfo: [],
            },
            rejectionComment: '',
            dialogStatus: null,
            isLoadCompleted: false,
        }

        this.ownUrl = this.props.location.pathname
        this.componentRef = React.createRef()

        this.handleDialogCancelClick = this.handleDialogCancelClick.bind(this)
        this.handleReceptionClick = this.handleReceptionClick.bind(this)
        this.handleReceptionOkClick = this.handleReceptionOkClick.bind(this)
        this.handleRejectionClick = this.handleRejectionClick.bind(this)
        this.handleRejectionOkClick = this.handleRejectionOkClick.bind(this)
        this.handleRejectionCommentChange = this.handleRejectionCommentChange.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await this.getApplyInfo()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getApplyInfo(): Promise<void> {
        const [contactAddressOnEmergencyResponse, applicationStatusResponse] = await Promise.all([
            this.getContactAddressOnEmergency(),
            this.getApplicationStatus(),
        ])

        if (contactAddressOnEmergencyResponse && applicationStatusResponse) {
            this.setState({
                contactAddressOnEmergencyDetail: contactAddressOnEmergencyResponse,
                applicationStatusDetail: applicationStatusResponse,
            })
        }
    }

    async getContactAddressOnEmergency(): Promise<Nullable<NatContactAddressOnEmergencyDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getContactAddressOnEmergency.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    async getApplicationStatus(): Promise<Nullable<NatGetApplicationStatusDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getApplicationStatus.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    handleDialogCancelClick(): void {
        this.setState({dialogStatus: null})
    }

    handleReceptionClick(): void {
        this.setState({dialogStatus: 'reception'})
    }

    handleRejectionClick(): void {
        this.setState({dialogStatus: 'rejection'})
    }

    handleRejectionCommentChange(value: string): void {
        this.setState({rejectionComment: value})
    }

    async handleRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, contactAddressOnEmergencyDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionContactAddressOnEmergencyRequest = {
                operation: RESIDENT_APPLY_PROCESS.RECEPTION.value,
                comment: rejectionComment,
                version: contactAddressOnEmergencyDetail.version,
            }

            const response: Nullable<NatPutRejectionContactAddressOnEmergencyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionContactAddressOnEmergency
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0004.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleReceptionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {contactAddressOnEmergencyDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsContactAddressOnEmergencyRequest = {
                operation: RESIDENT_APPLY_PROCESS.RECEPTION.value,
                version: contactAddressOnEmergencyDetail.version,
            }

            const response: Nullable<NatPutApprovalContactAddressOnEmergencyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalContactAddressOnEmergency
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0003.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    renderOccupancyDate(occupancyDate: string): ReactNode {
        return (
            <TableRow>
                <TableRowName>入居年月日</TableRowName>
                <StyledTableCell colSpan={4}>
                    {getFormattedDate(occupancyDate)}
                </StyledTableCell>
            </TableRow>
        )
    }

    renderContactAddressOnEmergency(
        residenceStyle: string,
        contactAddressOnEmergency: NatContactAddressOnEmergency,
    ): ReactNode {
        const {
            familyName,
            firstName,
            zipCode,
            prefecture,
            address2,
            address3,
            buildingRoomNumber,
            fixedPhoneNumber,
            mobilePhoneNumber,
        } = contactAddressOnEmergency

        switch (residenceStyle) {
            case RESIDENCE_STYLE.UNIT_OWNER.value:
            case RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value:
                return (
                    <>
                        <TableRow>
                            <TableRowNameTop rowSpan={2}>緊急時連絡先</TableRowNameTop>
                            <SecondaryTableRowName>
                                固定電話番号
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {fixedPhoneNumber}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName end>
                                携帯電話番号
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3} end>
                                {mobilePhoneNumber}
                            </SecondaryTableCell>
                        </TableRow>
                    </>
                )
            case RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value:
                const address = getFormattedAddress(
                    getStringOrEmptyString(zipCode),
                    getStringOrEmptyString(prefecture),
                    getStringOrEmptyString(address2),
                    getStringOrEmptyString(address3),
                    getStringOrEmptyString(buildingRoomNumber),
                )

                return (
                    <>
                        <TableRow>
                            <TableRowNameTop rowSpan={4}>緊急時連絡先</TableRowNameTop>
                            <SecondaryTableRowName>
                                氏名
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {familyName} {firstName}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                住所
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {address}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                固定電話番号
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {fixedPhoneNumber}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName end>
                                携帯電話番号
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3} end>
                                {mobilePhoneNumber}
                            </SecondaryTableCell>
                        </TableRow>
                    </>
                )
        }
    }

    renderAbsenceContactAddress(absenceContactAddress: NatAbsenceContactAddress): ReactNode {
        const {
            familyName,
            firstName,
            zipCode,
            prefecture,
            address2,
            address3,
            buildingRoomNumber,
            fixedPhoneNumber,
            mobilePhoneNumber,
        } = absenceContactAddress

        const address = getFormattedAddress(
            getStringOrEmptyString(zipCode),
            getStringOrEmptyString(prefecture),
            getStringOrEmptyString(address2),
            getStringOrEmptyString(address3),
            getStringOrEmptyString(buildingRoomNumber),
        )

        return (
            <>
                <TableRow>
                    <TableRowNameTop rowSpan={4}>上記連絡先不在などの場合の<br/>連絡先</TableRowNameTop>
                    <SecondaryTableRowName>
                        氏名
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {familyName} {firstName}
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName>
                        住所
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {address}
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName>
                        固定電話番号
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {fixedPhoneNumber}
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName end>
                        携帯電話番号
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3} end>
                        {mobilePhoneNumber}
                    </SecondaryTableCell>
                </TableRow>
            </>
        )
    }

    renderFamilyStructure(familyStructure: NatFamilyStructure): ReactNode {
        const {
            seq,
            relationship,
            familyName,
            firstName,
            familyNameKana,
            firstNameKana,
            birthDate,
            workAddress,
        } = familyStructure

        const address = getFormattedAddress(
            getStringOrEmptyString(workAddress.zipCode),
            getStringOrEmptyString(workAddress.prefecture),
            getStringOrEmptyString(workAddress.address2),
            getStringOrEmptyString(workAddress.address3),
            getStringOrEmptyString(workAddress.buildingRoomNumber),
        )

        return (
            <React.Fragment key={seq}>
                <TableRow>
                    <TableRowNameTop rowSpan={6}>家族{toFullWidthNumber(seq)}</TableRowNameTop>
                    <SecondaryTableRowName>
                        続柄
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {relationship}
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName>
                        氏名
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {familyName} {firstName}（{familyNameKana} {firstNameKana}）
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName>
                        生年月日
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {birthDate && moment(birthDate).format('YYYY年M月D日')}
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName>
                        勤務先
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {workAddress.name}
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName>
                        勤務先住所
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {address}
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName end>
                        勤務先電話番号
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3} end>
                        {workAddress.phoneNumber}
                    </SecondaryTableCell>
                </TableRow>
            </React.Fragment>
        )
    }

    renderRentAdminContactAddress(rentAdminContactAddress: NatRentAdminContactAddress): ReactNode {
        const {
            name,
            zipCode,
            prefecture,
            address2,
            address3,
            buildingRoomNumber,
            phoneNumber,
        } = rentAdminContactAddress

        const address = getFormattedAddress(
            getStringOrEmptyString(zipCode),
            getStringOrEmptyString(prefecture),
            getStringOrEmptyString(address2),
            getStringOrEmptyString(address3),
            getStringOrEmptyString(buildingRoomNumber),
        )

        return (
            <>
                <TableRow>
                    <TableRowNameTop rowSpan={4}>賃貸管理者連絡先</TableRowNameTop>
                    <SecondaryTableRowName>
                        名称
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {name}
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName>
                        電話番号
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3}>
                        {phoneNumber}
                    </SecondaryTableCell>
                </TableRow>
                <TableRow>
                    <SecondaryTableRowName end>
                        住所
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={3} end>
                        {address}
                    </SecondaryTableCell>
                </TableRow>
            </>
        )
    }

    renderDetailsTable(): ReactNode {
        const {
            applyId,
            residenceStyle,
            applyDate,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            occupancyDate,
            contactAddressOnEmergency,
            absenceContactAddress,
            familyStructure,
            rentAdminContactAddress,
            rentAdminContactAddressFlag,
        } = this.state.contactAddressOnEmergencyDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <>
                <Table>
                    <StyledTableCaption>申請内容</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>申請ID</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {applyId}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請区分</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {APPLY_CATEGORY.CONTACT_ADDRESS_ON_EMERGENCY.label}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>居住形態</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {RESIDENCE_STYLE.codeToEnumConstants(residenceStyle).label}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請者</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {condominiumName + '　' + applicant}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請日</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {moment(applyDate).format('YYYY年M月D日 H時m分')}
                            </StyledTableCell>
                        </TableRow>
                        {residenceStyle !== RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value &&
                            this.renderOccupancyDate(occupancyDate)
                        }
                        {this.renderContactAddressOnEmergency(residenceStyle, contactAddressOnEmergency)}
                        {this.renderAbsenceContactAddress(absenceContactAddress)}
                        {residenceStyle !== RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value &&
                            familyStructure.map(familyStructureInfo => this.renderFamilyStructure(familyStructureInfo))
                        }
                        {residenceStyle !== RESIDENCE_STYLE.UNIT_OWNER.value &&
                            rentAdminContactAddressFlag !== HAVE_OR_NOT.NOT.value &&
                            this.renderRentAdminContactAddress(rentAdminContactAddress)
                        }
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageHeaderArea(): ReactNode {
        const {contactAddressOnEmergencyDetail} = this.state

        return (
            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                <Box mt={'20px'}>
                    <RightRowFlexContainer>
                        <ReactToPrint
                            trigger={() => (
                                <PrintLink>
                                    <Box ml={'4px'}>
                                        印刷する
                                    </Box>
                                </PrintLink>
                            )}
                            content={() => this.componentRef.current}/>
                        <PrintContentArea>
                            <div ref={this.componentRef}>
                                <NatContactAddressEmergencyApplicationDocument
                                    contactAddressEmergencyApplyFormParam={contactAddressOnEmergencyDetail}
                                />
                            </div>
                        </PrintContentArea>
                    </RightRowFlexContainer>
                </Box>
            </AuthorityChecker>
        )
    }

    renderPageFooterArea(): ReactNode {
        const {contactAddressOnEmergencyDetail} = this.state

        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧に戻る
                    </BackLink>
                </PageFotterAreaLeft>
                {(contactAddressOnEmergencyDetail.applyStatus !== RESIDENT_APPLY_STATUS.COMPLETE.value &&
                        contactAddressOnEmergencyDetail.applyStatus !== RESIDENT_APPLY_STATUS.REJECTION.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><Box ml={'8px'}/>受け付ける
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
            </>
        )
    }

    renderSpOccupancyDate(occupancyDate: string): ReactNode {
        return (
            <SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContentName>入居年月日</SpApplicationDetailInfoContentName>
                <SpApplicationDetailInfoContentValue>
                    {getFormattedDate(occupancyDate)}
                </SpApplicationDetailInfoContentValue>
            </SpApplicationDetailInfoContent>
        )
    }

    renderSpContactAddressOnEmergency(
        residenceStyle: string,
        contactAddressOnEmergency: NatContactAddressOnEmergency,
    ): ReactNode {
        const {
            familyName,
            firstName,
            zipCode,
            prefecture,
            address2,
            address3,
            buildingRoomNumber,
            fixedPhoneNumber,
            mobilePhoneNumber,
        } = contactAddressOnEmergency

        switch (residenceStyle) {
            case RESIDENCE_STYLE.UNIT_OWNER.value:
            case RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT.value:
                return (
                    <SpApplicationDetailInfoContent>
                        <SpApplicationDetailInfoContentName>緊急時連絡先</SpApplicationDetailInfoContentName>
                        <SpApplicationDetailInfoContentValue>
                            {`固定電話番号：${fixedPhoneNumber ?? ''}`}
                        </SpApplicationDetailInfoContentValue>
                        <SpApplicationDetailInfoContentValue>
                            {`携帯電話番号：${mobilePhoneNumber ?? ''}`}
                        </SpApplicationDetailInfoContentValue>
                    </SpApplicationDetailInfoContent>
                )
            case RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value:
                const address = getFormattedAddress(
                    getStringOrEmptyString(zipCode),
                    getStringOrEmptyString(prefecture),
                    getStringOrEmptyString(address2),
                    getStringOrEmptyString(address3),
                    getStringOrEmptyString(buildingRoomNumber),
                )

                return (<SpApplicationDetailInfoContent>
                        <SpApplicationDetailInfoContentName>緊急時連絡先</SpApplicationDetailInfoContentName>
                        <SpApplicationDetailInfoContentValue>
                            {`氏名：${familyName ?? ''} ${firstName ?? ''}`}
                        </SpApplicationDetailInfoContentValue>
                        <SpApplicationDetailInfoContentValue>
                            {`住所：${address ?? ''}`}
                        </SpApplicationDetailInfoContentValue>
                        <SpApplicationDetailInfoContentValue>
                            {`固定電話番号：${fixedPhoneNumber ?? ''}`}
                        </SpApplicationDetailInfoContentValue>
                        <SpApplicationDetailInfoContentValue>
                            {`携帯電話番号：${mobilePhoneNumber ?? ''}`}
                        </SpApplicationDetailInfoContentValue>
                    </SpApplicationDetailInfoContent>
                )
        }
    }

    renderSpAbsenceContactAddress(absenceContactAddress: NatAbsenceContactAddress): ReactNode {
        const {
            familyName,
            firstName,
            zipCode,
            prefecture,
            address2,
            address3,
            buildingRoomNumber,
            fixedPhoneNumber,
            mobilePhoneNumber,
        } = absenceContactAddress

        const address = getFormattedAddress(
            getStringOrEmptyString(zipCode),
            getStringOrEmptyString(prefecture),
            getStringOrEmptyString(address2),
            getStringOrEmptyString(address3),
            getStringOrEmptyString(buildingRoomNumber),
        )

        return (
            <SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContentName>上記連絡先不在などの場合の連絡先</SpApplicationDetailInfoContentName>
                <SpApplicationDetailInfoContentValue>
                    {`氏名：${familyName ?? ''} ${firstName ?? ''}`}
                </SpApplicationDetailInfoContentValue>
                <SpApplicationDetailInfoContentValue>
                    {`住所：${address ?? ''}`}
                </SpApplicationDetailInfoContentValue>
                <SpApplicationDetailInfoContentValue>
                    {`固定電話番号：${fixedPhoneNumber ?? ''}`}
                </SpApplicationDetailInfoContentValue>
                <SpApplicationDetailInfoContentValue>
                    {`携帯電話番号：${mobilePhoneNumber ?? ''}`}
                </SpApplicationDetailInfoContentValue>
            </SpApplicationDetailInfoContent>
        )
    }

    renderSpFamilyStructure(familyStructure: NatFamilyStructure): ReactNode {
        const {
            seq,
            relationship,
            familyName,
            firstName,
            familyNameKana,
            firstNameKana,
            birthDate,
            workAddress,
        } = familyStructure

        const address = getFormattedAddress(
            getStringOrEmptyString(workAddress.zipCode),
            getStringOrEmptyString(workAddress.prefecture),
            getStringOrEmptyString(workAddress.address2),
            getStringOrEmptyString(workAddress.address3),
            getStringOrEmptyString(workAddress.buildingRoomNumber),
        )

        return (
            <React.Fragment key={seq}>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>
                        家族{toFullWidthNumber(seq)}
                    </SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {`続柄：${relationship ?? ''}`}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        {`氏名：${familyName ?? ''} ${firstName ?? ''}（${familyNameKana ?? ''} ${firstNameKana ?? ''}）`}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        {`生年月日：${birthDate ? moment(birthDate).format('YYYY年M月D日') : ''}`}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        {`勤務先：${workAddress.name ?? ''}`}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        {`勤務先住所：${address ?? ''}`}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        {`勤務先電話番号：${workAddress.phoneNumber ?? ''}`}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
            </React.Fragment>
        )
    }

    renderSpRentAdminContactAddress(rentAdminContactAddress: NatRentAdminContactAddress): ReactNode {
        const {
            name,
            zipCode,
            prefecture,
            address2,
            address3,
            buildingRoomNumber,
            phoneNumber,
        } = rentAdminContactAddress

        const address = getFormattedAddress(
            getStringOrEmptyString(zipCode),
            getStringOrEmptyString(prefecture),
            getStringOrEmptyString(address2),
            getStringOrEmptyString(address3),
            getStringOrEmptyString(buildingRoomNumber),
        )

        return (
            <SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContentName>賃貸管理者連絡先</SpApplicationDetailInfoContentName>
                <SpApplicationDetailInfoContentValue>
                    {`名称：${name ?? ''}`}
                </SpApplicationDetailInfoContentValue>
                <SpApplicationDetailInfoContentValue>
                    {`電話番号：${phoneNumber ?? ''}`}
                </SpApplicationDetailInfoContentValue>
                <SpApplicationDetailInfoContentValue>
                    {`住所：${address ?? ''}`}
                </SpApplicationDetailInfoContentValue>
            </SpApplicationDetailInfoContent>
        )
    }

    renderSpApplicationDetailInfo(): ReactNode {
        const {
            residenceStyle,
            occupancyDate,
            contactAddressOnEmergency,
            absenceContactAddress,
            familyStructure,
            rentAdminContactAddressFlag,
            rentAdminContactAddress,
            applyStatus,
        } = this.state.contactAddressOnEmergencyDetail

        return (
            <>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>居住形態</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {RESIDENCE_STYLE.codeToEnumConstants(residenceStyle).label}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                {residenceStyle !== RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value &&
                    this.renderSpOccupancyDate(occupancyDate)
                }
                {this.renderSpContactAddressOnEmergency(residenceStyle, contactAddressOnEmergency)}
                {this.renderSpAbsenceContactAddress(absenceContactAddress)}
                {residenceStyle !== RESIDENCE_STYLE.EXTERNAL_UNIT_OWNER.value &&
                    familyStructure.map(familyStructureInfo => this.renderSpFamilyStructure(familyStructureInfo))
                }
                {residenceStyle !== RESIDENCE_STYLE.UNIT_OWNER.value &&
                    rentAdminContactAddressFlag !== HAVE_OR_NOT.NOT.value &&
                    this.renderSpRentAdminContactAddress(rentAdminContactAddress)
                }
                {(applyStatus !== RESIDENT_APPLY_STATUS.COMPLETE.value &&
                        applyStatus !== RESIDENT_APPLY_STATUS.REJECTION.value) &&
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                        <SpPageFooterArea>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><Box ml={'8px'}/>受け付ける
                            </ApplyReceptionOutlinedButton>
                        </SpPageFooterArea>
                    </AuthorityChecker>
                }
            </>)
    }

    renderSpApplicationStatusInfo(): ReactNode {
        return (<NatApplicationStatusComponent
            currentApplyStatus={this.state.contactAddressOnEmergencyDetail.applyStatus}
            applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
        />)
    }

    renderSpApplicantInfo(): ReactNode {
        const {
            applyId,
            applyStatus,
            applyDate,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        } = this.state.contactAddressOnEmergencyDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <SpApplicationInfoArea>
                <LeftColumnFlexContainer>
                    {applyId}
                    <FullWidthRowFlexContainer>
                        <SpApplyCategory>
                            {APPLY_CATEGORY.CONTACT_ADDRESS_ON_EMERGENCY.label}
                        </SpApplyCategory>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                            <ReactToPrint
                                trigger={() => (
                                    <PrintLink>
                                        <Box ml={'10px'}>
                                            印刷する
                                        </Box>
                                    </PrintLink>
                                )}
                                content={() => this.componentRef.current}/>
                            <PrintContentArea>
                                <div ref={this.componentRef}>
                                    <NatContactAddressEmergencyApplicationDocument
                                        contactAddressEmergencyApplyFormParam={
                                            this.state.contactAddressOnEmergencyDetail}
                                    />
                                </div>
                            </PrintContentArea>
                        </AuthorityChecker>
                    </FullWidthRowFlexContainer>
                    <Box height={'12px'}/>
                    {condominiumName}<br/>
                    {applicant}
                    <Box height={'12px'}/>
                    <SpApplicationInfoFooter>
                        <div>
                            {formatDateTimeWithoutSeconds(applyDate)} に提出
                        </div>
                        <SpApplyStatusCell status={applyStatus}>
                            {RESIDENT_APPLY_STATUS.codeToEnumConstants(applyStatus).label}
                        </SpApplyStatusCell>
                    </SpApplicationInfoFooter>
                </LeftColumnFlexContainer>
            </SpApplicationInfoArea>
        )
    }

    renderSp(): Nullable<ReactElement> {
        return (
            <>
                <SpBackLinkArea>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧
                    </BackLink>
                </SpBackLinkArea>
                {this.renderSpApplicantInfo()}
                <Box height={'16px'}/>
                <NatAdminSpApplicationTabComponent
                    detailInfo={this.renderSpApplicationDetailInfo()}
                    statusInfo={this.renderSpApplicationStatusInfo()}
                />
                <Box height={`32px`}/>
            </>
        )
    }

    renderPc(): Nullable<ReactElement> {
        return (
            <>
                <Box mb={'20px'}>
                    {this.renderPageHeaderArea()}
                </Box>
                <PageMainArea>
                    {this.renderDetailsTable()}
                    <NatApplicationStatusComponent
                        currentApplyStatus={this.state.contactAddressOnEmergencyDetail.applyStatus}
                        applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                    />
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const spMode = this.context.showSpModePage

        return (
            <>
                {spMode ? this.renderSp() : this.renderPc()}
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'rejection'}
                    residentApplyProcess={RESIDENT_APPLY_PROCESS.RECEPTION}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationReceptionDialog
                    open={this.state.dialogStatus === 'reception'}
                    onCancel={this.handleDialogCancelClick}
                    onReception={this.handleReceptionOkClick}
                    eventEmitter={this.props.eventEmitter}
                />
            </>
        )
    }
}

NatAdminContactAddressOnEmergencyPage.contextType = AppAdminContext
export default createAdminPage(NatAdminContactAddressOnEmergencyPage)
